import { type useIntegrationEhrInfo } from '@/hooks/integrations/useIntegrationEhrInfo';
import { type AvailableStandardizedSection } from '@heidi/integrations/ehr/contracts';
import { createContext, useContext } from 'react';

export type SectionLinkHandler = (
  sectionHeading: string,
  ehrSectionId: string | null
) => void;

export interface SectionEhrContextValue {
  integrationEhrProvider: ReturnType<
    typeof useIntegrationEhrInfo
  >['integrationEhrProvider'];
  canSyncSectionalNotes: boolean;
  availableStandardizedSections: AvailableStandardizedSection[] | undefined;
  onSectionLink?: SectionLinkHandler;
}

export const SectionEhrContext = createContext<SectionEhrContextValue | null>(null);

export function useSectionEhrContext(): SectionEhrContextValue {
  const ctx = useContext(SectionEhrContext);
  if (!ctx) {
    return {
      integrationEhrProvider: undefined,
      canSyncSectionalNotes: false,
      availableStandardizedSections: undefined,
    };
  }
  return ctx;
}
